<template>
  <div style="height:100%">
    <!-- <van-loading class="xc-center" size="24px" vertical>加载中...</van-loading> -->
    <div class="camera-container">
      <p>声明：本产品仅为辅助工具，对查奖准确性不做保证，中奖情况以官方开奖公告及兑奖结果为准</p>
      <div class="content">
        <canvas ref="canvasEl" class="kk"></canvas>
        <video class="kk" playsinline ref="videoEl" autoplay></video>
        <video class="kk1" playsinline ref="video1El" autoplay></video>
      </div>

      <div style="position:absolute; bottom:120px;color: #fff;left: 10px;">
        <p style="text-align: left; margin:10px;">将彩票正面放入框内拍照，确保彩种、期次、投注号码完整拍摄</p>
        <p style="text-align: left; margin:10px;">目前只支持大乐透/双色球/福彩3D/排列3/7星彩/排列5/快乐8</p>
      </div>
      <div style="position:absolute; height:100px; bottom:0; width: 100%; display:flex; justify-content:flex-start">
        <div style="width:33%;">
          <van-uploader :after-read="onRead">
            <van-icon color="var(--color-white)" size="50px" name="photo" />
          </van-uploader>
        </div>

        <div style="width:33%;">
          <van-icon color="var(--color-white)" size="50px" @click=takePhoto name="photograph" />
        </div>

      </div>
    </div>
  </div>

</template>
<script setup>
import { ref, reactive, onMounted, nextTick, toRaw } from 'vue'

import { beforeRead, dataURLtoFile } from '@/LottHelper'
import { showToast, Loading } from 'vant'

import axios from 'axios'

const videoEl = ref('')
const video1El = ref('')
const canvasEl = ref('')

const props = defineProps({
  scan: { type: Function, default: null },
  isMobile: { type: Boolean, default: false },
})

onMounted(() => {
  const video = videoEl.value;
  const video1 = video1El.value;

  let constraints = {};

  if (props.isMobile) {
    constraints = {
      video: {
        facingMode: { exact: "environment" } // 后置摄像头
      }
    };
  } else {
    constraints = { video: true };
  }

  if (navigator.mediaDevices) {
    // 创建MediaDevices对象
    navigator.mediaDevices.getUserMedia(constraints)
      .then(stream => {
        // alert(video);
        video.srcObject = stream;
        video.play();
        video1.srcObject = stream;
        video1.play();
      })
      .catch(error => {
        console.log('无法打开摄像头', error);
      });
  }
})

const onRead = (file) => {

  phPa(file.file);
}

const takePhoto = async () => {


  //   let data = {
  //     "success": true,
  //     "ocrResList": [
  //         {
  //             "res": [
  //                 [
  //                     "02",
  //                     "14",
  //                     "20",
  //                     "25",
  //                     "32"
  //                 ],
  //                 [],
  //                 [
  //                     "10",
  //                     "12"
  //                 ],
  //                 []
  //             ],
  //             "resList": [],
  //             "beishu": 1
  //         },
  //         {
  //             "res": [
  //                 [
  //                     "12",
  //                     "18",
  //                     "23",
  //                     "29",
  //                     "32"
  //                 ],
  //                 [],
  //                 [
  //                     "10",
  //                     "12"
  //                 ],
  //                 []
  //             ],
  //             "resList": [],
  //             "beishu": 1
  //         },
  //         {
  //             "res": [
  //                 [
  //                     "03",
  //                     "12",
  //                     "15",
  //                     "28",
  //                     "35"
  //                 ],
  //                 [],
  //                 [
  //                     "10",
  //                     "12"
  //                 ],
  //                 []
  //             ],
  //             "resList": [],
  //             "beishu": 1
  //         },
  //         {
  //             "res": [
  //                 [
  //                     "13",
  //                     "30",
  //                     "31",
  //                     "34",
  //                     "35"
  //                 ],
  //                 [],
  //                 [
  //                     "10",
  //                     "12"
  //                 ],
  //                 []
  //             ],
  //             "resList": [],
  //             "beishu": 1
  //         },
  //         {
  //             "res": [
  //                 [
  //                     "09",
  //                     "24",
  //                     "25",
  //                     "26",
  //                     "28"
  //                 ],
  //                 [],
  //                 [
  //                     "10",
  //                     "12"
  //                 ],
  //                 []
  //             ],
  //             "resList": [],
  //             "beishu": 1
  //         },
  //         {
  //             "res": [
  //                 [
  //                     "09",
  //                     "14",
  //                     "31",
  //                     "32",
  //                     "34"
  //                 ],
  //                 [],
  //                 [
  //                     "10",
  //                     "12"
  //                 ],
  //                 []
  //             ],
  //             "resList": [],
  //             "beishu": 1
  //         },
  //         {
  //             "res": [
  //                 [
  //                     "02",
  //                     "21",
  //                     "26",
  //                     "30",
  //                     "35"
  //                 ],
  //                 [],
  //                 [
  //                     "10",
  //                     "12"
  //                 ],
  //                 []
  //             ],
  //             "resList": [],
  //             "beishu": 1
  //         },
  //         {
  //             "res": [
  //                 [
  //                     "03",
  //                     "04",
  //                     "07",
  //                     "26",
  //                     "35"
  //                 ],
  //                 [],
  //                 [
  //                     "10",
  //                     "12"
  //                 ],
  //                 []
  //             ],
  //             "resList": [],
  //             "beishu": 1
  //         },
  //         {
  //             "res": [
  //                 [
  //                     "17",
  //                     "21",
  //                     "27",
  //                     "29",
  //                     "30"
  //                 ],
  //                 [],
  //                 [
  //                     "10",
  //                     "12"
  //                 ],
  //                 []
  //             ],
  //             "resList": [],
  //             "beishu": 1
  //         },
  //         {
  //             "res": [
  //                 [
  //                     "05",
  //                     "12",
  //                     "17",
  //                     "19",
  //                     "27"
  //                 ],
  //                 [],
  //                 [
  //                     "10",
  //                     "12"
  //                 ],
  //                 []
  //             ],
  //             "resList": [],
  //             "beishu": 1
  //         }
  //     ],
  //     "qiHao": "23111",
  //     "name": "超级大乐透",
  //     "wanFa": "单式"
  // }
  // props.scan(3, data);
  //   return;

  const canvas = canvasEl.value;
  const video = videoEl.value;
  const video1 = video1El.value;
  let ctx = canvas.getContext('2d');

  canvas.width = 900;
  canvas.height = 1200;

  ctx.drawImage(video1, 0, 0, canvas.width, canvas.height);

  video.style.display = 'none';
  video1.style.display = 'none';

  let file = dataURLtoFile(canvas.toDataURL(), 'file');
  phPa(file);
}

const phPa = file => {

  beforeRead(file).then((f) => {
    console.log('fffffff:', f);

    let formData = new FormData()
    formData.append('file', f)

    console.log('formData:', formData);

    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 7000,
      CTM: true
    }

    axios.post(window.url1 + 'api/User/GetLotteryByImage', formData, config).then((res) => {
      let data = res.data;
      if (data.code == 0) {
        if (data.data.success) {
          //成功
          props.scan(3, data.data);
        } else {
          props.scan(2);
        }
      }
    }).catch((e) => {

      console.log('e.response.data.Message:', e.response);

      if (e.response.data.Message) {
        showToast(e.response.data.Message);
      } else {
        showToast('验证彩票失败！');
      }
    })
  })
}

const state = reactive({
  loading: false,
})

</script>
<style lang="less" scoped>
.btnCls {
  --van-button-primary-color: #000;
  --van-button-primary-background: var(--color-0008);

  font-weight: 600;

}

.camera-container {
  width: 100%;
  /* 设置容器大小 */
  height: 100%;
  background-color: #000;
  text-align: center;

  .content {
    position: absolute;
    width: 300px;
    height: 400px;
    display: inline-block;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);

    .kk {
      position: absolute;
      left: 0;
      top: 0;
      height: 400px;
      width: 300px;
    }

    .kk1 {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      height: 1200px;
      width: 900px;
    }
  }

  >p {
    font-size: 12px;
    color: #fff;
    margin: 0px;
    padding-left: 10px;
    padding-top: 10px;
    text-align: left;
    margin-bottom: 10px;
  }

  .btn {
    width: 60px;
    height: 60px;
    background-color: #fff;
    display: inline-block;
    margin-top: 40px;
    border-radius: 30px;
  }
}
</style>